import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import ModalControls from "../../common/ModalControls";
import { useNavigate, useLocation } from "react-router-dom";
import { defaultFormState } from "../../../../defaults/Forms";
import { timeCardDefault } from "../../../../defaults/Items";

import {
  onSaveAndClose,
  compareData,
  restoreFormData,
  onItemsListDeleteButtonClick,
  onCloseDetails, setForegroundColor
} from "../../../../helpers/ComponentHelper";

import AppComponentCardHeader from "../../common/AppComponentCardHeader";
import LoadingDataDiv from "../../common/LoadingDataDiv";
import DeleteWarningModal from "../../common/DeleteWarningModal";
import TextInput from "../../../elements/TextInput";
import TextArea from "../../../elements/TextArea";
import useCrud from "../../../../hooks/useCrud";
import { Table } from "../../../table/Table";

import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import Toggler from "../../../elements/Toggler";
import {HexColorPicker} from "react-colorful";
import NumberInput from "../../../elements/NumberInput";
import {faQuestionCircle} from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import {Modal} from "react-bootstrap";
import "../../../../css/ResourceTables.css";


const TimeCard = () => {

  const dataUrl = "/time-cards";
  const relatedItemsUrl = null; // if no need to check it, initialize with null and remove RelatedItemsList from details modal
  const defaultItem = timeCardDefault;
  const itemName = "Karta RCP";
  const itemNames = "Karty RCP";
  const navigate = useNavigate();
  const location = useLocation();
  const {createItem, updateItem, deleteItem, getItems, getRelatedChildrenByParentId} = useCrud(dataUrl);

  const [loading, setLoading] = useState(true);
  const [allowDelete, setAllowDelete] = useState(null);
  const [currentFormState, setCurrentFormState] = useState(defaultFormState);
  const [itemsList, setItems] = useState([]);
  const [currentItem, setCurrentItem] = useState(defaultItem);
  const [backupItem, setBackupItem] = useState(defaultItem);
  const [itemChanged, setItemChanged] = useState(false);
  const [updateConflict, setUpdateConflict] = useState(false);
  const employeesUrl = "/employees";


  // elements related to the item
  const columns = [
    {label: "Id", accessor: "id", sortable: true, searchable: false, visible: false},
    {label: "Identyfikator", accessor: "cardId", sortable: true, searchable: true},
    {label: "Pracownik", accessor: "employeeName", sortable: true, searchable: true},
    {
      label: "Przypisanie",
      accessor: "assignmentStatus",
      sortable: true,
      searchable: true,
      type: "optionsMap",
      optionsMap: ["Przypisana->A", "Nieprzypisana->N"],
      contentMap: "A='Przypisana';N='Nieprzypisana'"
    },
    {label: "Aktywna", accessor: "active", sortable: true, searchable: true, type: "bool"},
    {label: "Ważna", accessor: "valid", sortable: true, searchable: true, type: "bool"},
    {label: "Edycja", accessor: "editBtn", sortable: false, searchable: false},
    {label: "Usuń", accessor: "deleteBtn", sortable: false, searchable: false},
  ];


  const state = {
    itemsList, setItems,
    currentItem, setCurrentItem,
    currentFormState, setCurrentFormState,
    defaultItem, backupItem, setBackupItem, itemChanged, setItemChanged,
    setAllowDelete,
    setRelatedItems: null
  }


  const onDelete = async () => {
    const response = await deleteItem(`${dataUrl}/${currentItem.id}`, currentItem.id, state);
    if (response === 401 || response === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    }
  }


  const onSaveItemClick = async (e) => {
    e.preventDefault();

      if (!currentItem.cardId) {
        let cardIdInput = document.getElementById("cardId");
        cardIdInput.classList.add("form-input-invalid");
        cardIdInput.placeholder = `ten element jest wymagany`;
        return;
      }



    let response;
    const item = {
      id: currentItem.id,
      cardId: currentItem.cardId,
      pin: currentItem.pin,
      notes: currentItem.notes,
      employeeId: currentItem.employeeId,
      active: currentItem.active,
      valid: currentItem.valid
    };

    if (currentFormState.formAddingDataMode) {
      response = await createItem(dataUrl, item, state);
    } else {
      response = await updateItem(`${dataUrl}/${item.id}`, item, state);
    }

    if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    } else if (response.status === 409) {
      setUpdateConflict(true);

    } else {
      response && onSaveAndClose({state});
    }
  }

  const checkRelatedItems = async (id) => {
    //const data = await getRelatedChildrenByParentId(`${ relatedItemsUrl }/${ id }`, id, setEventsList);
    //data.length === 0 ? setAllowDelete(true) : setAllowDelete(false);
    setAllowDelete(true);
  }


  const onClose = () => {
    setUpdateConflict(false);
    onCloseDetails({state});
  };


  useEffect(() => {
    if (updateConflict) setUpdateConflict(false);
    compareData(currentFormState, setCurrentFormState, currentItem, backupItem);
  }, [itemChanged])


  useEffect(() => {
    if (allowDelete !== null) {
      onItemsListDeleteButtonClick(currentFormState, setCurrentFormState, itemName, allowDelete, currentItem.name);
    }
  }, [allowDelete])


  useEffect(() => {
    const getData = async () => {
      const [cardsResponse, employeesResponse] = await Promise.all([
        getItems(dataUrl),
        getItems(employeesUrl)
      ]);

      if (cardsResponse.status === 200 && employeesResponse.status === 200) {
        const employeesById = new Map(
          (employeesResponse.data || []).map(employee => [
            Number(employee.id),
            `${employee.firstName || ""} ${employee.lastName || ""}`.trim() || employee.login || `#${employee.id}`
          ])
        );
        const cards = (cardsResponse.data || []).map(card => ({
          ...card,
          employeeName: card.employeeId == null
            ? "Nieprzypisana"
            : employeesById.get(Number(card.employeeId)) || `Pracownik #${card.employeeId}`,
          assignmentStatus: card.employeeId == null ? "N" : "A"
        }));
        setItems(cards);
        setLoading(false);
      } else if ([cardsResponse.status, employeesResponse.status].some(status => status === 401 || status === 403)) {
        navigate('/login', {state: {from: location}, replace: true});
      } else {
        alert("Nie udało się pobrać danych.");
      }
    };
    getData();
  }, [])


  const getCompleteItem = async (id) => {
    const response = await getItems(`${dataUrl}/${id}`);
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true})
    } else {
      alert("Nie udało się pobrać danych.");
    }
  }


  const addDataButtonProps = {
    setCurrentItem,
    setBackupItem,
    defaultItem,
    currentFormState,
    setCurrentFormState,
    formDescription: `Tu możesz dodać nowy element.`,
    formHeader: `Nowy element`,
    buttonTitle: ` Dodaj nową kartę RCP`
  }


  let dataSectionContent;
  if (loading) {
    dataSectionContent = <LoadingDataDiv/>
  } else if (itemsList.length > 0) {
    dataSectionContent =
      <Table
        rows={itemsList}
        columns={columns}
        state={state}
        tableClassName="resource-object-table time-card-table"
        tableContainerClassName="resource-object-table-scroll"
        checkRelatedItems={checkRelatedItems}
        formHeader={`Edycja ${itemName}`}
        relatedItemsUrl={relatedItemsUrl}
        getCompleteItem={getCompleteItem}
        exportFileName="karty-rcp.xlsx"
      />
  } else {
    dataSectionContent =
      <div className={"warn_info"}><FontAwesomeIcon
        className={"warning-icon div-visible"} icon={faExclamationCircle}/>&nbsp;&nbsp;&nbsp;NIE ZNALEZIONO ŻADNYCH DANYCH</div>
  }


  return (
    <div id="layoutSidenav_content" className="resource-page">
      {currentFormState.showForm ?
        (<AppComponentCardHeader title={"Edycja pozycji słownika " + `${itemNames.charAt(0).toUpperCase()}${itemNames.slice(1).toLowerCase()}` + " -> " + currentItem.cardId}/>
        ) : (
          <AppComponentCardHeader title={"Pozycje słownika " + `${itemNames.charAt(0).toUpperCase()}${itemNames.slice(1).toLowerCase()}`}
                                  buttonProps={addDataButtonProps}
          />
        )}

      <div className="container-fluid px-4">
        <div
          className={
            itemsList.length > 0
              ? "card shadow-sm mb-5 bg-white rounded-2 resource-object-list-card time-card-list-card"
              : "card shadow mb-5 bg-transparent rounded-2"
          }
        >
          {dataSectionContent}
        </div>

        {currentFormState.showForm && (
          <Modal className="mt-5" show={true} backdrop="static" keyboard={false} size={'lg'}>

            <div className="custom-modal shadow rounded" id="modal_wrapper">
              <div className="custom-modal-body">
                <section className="mb-4">
                  <p className="text-center w-responsive mx-auto mb-1 form_test">
                    {currentFormState.formDescription}
                  </p>
                  <div>
                    <p
                      className="text-center w-responsive mx-auto mb-1 data_changed"
                      id="data-changed"
                    >
                      <FontAwesomeIcon icon={faExclamationCircle} />
                      &nbsp;{currentFormState.formDataChangedWarning}
                    </p>
                    <Button
                      variant="secondary"
                      id="btn-restore"
                      className="btn-restore"
                      onClick={() => {
                        setUpdateConflict(false)
                        restoreFormData({ state })
                      }}
                    >
                      Wyczyść zmiany
                    </Button>
                  </div>

                  <div className="col-md-12 mb-md-0 mb-5">
                    <form id="add-timeCard-form" name="add-timeCard-form">
                      <div className="row form-group mb-2">
                        <div className="col-md-2 form-label">
                          <label htmlFor="cardId">Identyfikator *</label>
                        </div>
                        <div className="col-md-2">
                          <TextInput propertyName="cardId" required={true} state={state} />
                        </div>
                      </div>

                      <div className="row form-group mb-2">
                        <div className="col-md-2 form-label">
                          <label htmlFor="pin">PIN karty *</label>
                        </div>
                        <div className="col-md-2">
                          <TextInput propertyName="pin" required={true} state={state} />
                        </div>
                      </div>

                      <div className="row form-group mb-2">
                        <div className="col-md-2 form-label">
                          <label htmlFor="active">Aktywna</label>
                        </div>
                        <div className="col-md-1">
                          <Toggler propertyName="active" state={state} />
                        </div>
                      </div>

                      <div className="row form-group mb-2">
                        <div className="col-md-2 form-label">
                          <label htmlFor="valid">Ważna</label>
                        </div>
                        <div className="col-md-1">
                          <Toggler propertyName="valid" state={state} />
                        </div>
                      </div>

                      <p
                        id="conflict_notification"
                        className={updateConflict ? "err_info" : "offscreen"}
                      >
                        <FontAwesomeIcon icon={faInfoCircle} />
                        &nbsp;Nie można dodać ani zmienić tego elementu, ponieważ
                        istnieje już wpis o tej nazwie i/lub skrócie
                      </p>
                    </form>
                  </div>
                </section>
              </div>
              <ModalControls
                onDelete={onDelete}
                onCloseDetails={onClose}
                onSubmit={onSaveItemClick}
                state={state}
              />
            </div>

          </Modal>
        )}
      </div>

      <DeleteWarningModal state={state} onDelete={onDelete} deleteItemName={itemName} />
    </div>
  )

}

export default TimeCard;
